/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import GroupType from '@linc-technologies/linced-common/enums/group-type';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class CurrentNewClassRoute extends Route {
  // Services
  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    let nextYear = parseInt(this.year, 10) + 1;
    return hash({
      currHomerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year: this.year,
      }),
      newHomerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year: nextYear,
      }),
    });
  }
}
